import heroimg from "../../../../../images/LandingPageImage/auto_reply_smart_flow.webp";
import "../../styles/LandingPageCss/MainHomeSection.css";
import FAQContactSection from "../LandingPagecomponents/FAQContactSection";
import google from "../../../../../images/LandingPageImage/google.png";

import { useModal } from "../../../../../MyContext";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";

export default function AutomatedReplies() {
  const { openModal } = useModal();
  return (
    <div>
      <Navbar />
      <section className="hero-section py-5 py-md-5 font-inter">
        <div className="container px-3 px-lg-4">
          <div className="row align-items-center gx-lg-5 gy-5">
            <div className="col-12 col-md-6 order-2 order-md-1">
              <div className="hero-content text-center text-md-start">
                <h1 className="hero-title text-purple font-spacegrotesk fw-semibold">
                  Automated Replies & Smart Flows: Smarter Conversations on
                  WhatsApp
                </h1>

                <p className="hero-subtitle mt-3">
                  Customers in an ever-changing digital world are demanding
                  quick answer to their questions and smooth flow of
                  communication. Slow responses may result in lost opportunities
                  and leads. Automated Replies and Smart Flows assist businesses
                  to respond instantly and lead a user through a conversation
                  and provide a more effective customer experience without
                  manual intervention.
                </p>

                <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                  <Link
                    to="/login"
                    className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{ width: "30px", height: "30px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "20px", height: "20px" }}
                        className="img-fluid"
                      />
                    </span>

                    <span className="text-nowrap fs-6">Start With Google</span>
                  </Link>
                  <button
                    onClick={openModal}
                    className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                  >
                    <span className="text-nowrap fs-5">Book a Demo</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 order-2 order-md-2">
              <div className="hero-image-wrapper d-flex justify-content-center align-items-center">
                <div className="hero-circle-bg">
                  <div className="circle-element "></div>
                  <img
                    src={heroimg}
                    alt="WhatsApp marketing dashboard"
                    className="hero-img img-fluid  rounded-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            What are Automated Reply and
            <br />
            Smart Flows?
          </h1>

          <p className="about-text text-dark mb-5">
            The automated replies are pre programmed messages that are
            automatically sent in the event of a user performing certain action
            like sending a message or clicking a button. Smart flows go a notch
            higher by establishing programmed conversation directions that
            direct users depending on their answers.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <div className="info-card text-start vision-card">
                <h3 className="text-dark font-spacegrotesk">
                  The reason why automation is important in WhatsApp marketing
                </h3>
                <p>
                  Individualized WhatsApp messaging allows businesses to
                  communicate with customers based on their specific goals,
                  behavior, and intent. By delivering relevant, personalized
                  conversations for lead generation, sales, support, and
                  retention, brands can improve engagement, conversions, and
                  long-term customer relationships.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card text-start  mission-card">
                <h3 className="font-spacegrotesk text-dark">
                  The way MsgNotifier Enables Smart Automation
                </h3>
                <p>
                  MsgNotifier provides advanced automation that turns WhatsApp
                  messages into interactive, conversational experiences for
                  customers. Businesses can create automatic responses, design
                  multi-step smart flows, capture leads, and track performance
                  effortlessly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            Best Practices for Effective
            <br />
            Automated Replies
          </h1>

          <p className="about-text text-dark mb-5">
            Automation in WhatsApp marketing can significantly enhance customer
            engagement when used correctly. Following best practices ensures
            that automated messages remain helpful, natural, and user-friendly,
            maximizing the impact of your campaigns.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Keep Messages Short, Clear, and Conversational
                </h3>
                <p className="text-white">
                  Automated replies should be concise and written in a natural
                  tone to avoid overwhelming or annoying users. Clear messaging
                  helps customers understand responses quickly and improves
                  engagement rates.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Enable Easy Navigation with Buttons and Quick Replies
                </h3>
                <p className="text-white">
                  Using buttons and quick reply options allows users to navigate
                  conversations effortlessly. This feature makes automated flows
                  more interactive and guides customers to the information or
                  actions they need.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Allow Human Handoff and Regular Flow Optimization
                </h3>
                <p className="text-white">
                  Automation should support human intervention when complex
                  queries arise, ensuring a seamless customer experience.
                  Regularly analyzing and optimizing conversation flows improves
                  performance and keeps engagement high.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  WhatsApp Campaign Management
                </h3>
                <p className="text-white">
                  Run bulk messaging campaigns, promotional broadcasts, and
                  personalized outreach with high delivery and engagement rates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FAQContactSection />
      <Footer />
    </div>
  );
}
